module.exports = function getResource(label) {
    const resources = {
        free: 'Free'
    };

    return resources[label];
};
